if (window.jQuery) {

    (function ($) {


        // Stop youtube video when clicking on next/previous slides
        $(".carousel-control-prev, .carousel-control-next").off('click').on('click', function (e) {

            var player, command;

            command = {
                "event": "command",
                "func": "pauseVideo"
            };

            $('.carousel .carousel-item iframe').each(function () {

                player = $(this).get(0);

                if (player != undefined) {
                    player.contentWindow.postMessage(JSON.stringify(command), "*");
                }

            });

        });

    })(jQuery);

}